module.exports = __webpack_public_path__ + "static/mobby-mockup-929de20e7b773b01ea29b372757f0e98.png";